import React from 'react';
import { OrderService, OrderSortBy, OrderStatus } from '../api';
import { OrdersTable } from './OrdersTable';

export const AllOrders = () => {
  const opId = 'getAllOrders';
  const fetchingMethod = (
    page?: number,
    perPage?: number,
    search?: string,
    sortBy?: OrderSortBy,
    orderPageIds?: string[],
    statuses?: OrderStatus[],
  ) => OrderService.getAllOrders(page, perPage, search, statuses, sortBy, orderPageIds);
  return <OrdersTable fetchingMethod={fetchingMethod} opId={opId} />;
};
